// [목적] App 셸이 Outlet context 로 내려주는 (viewport, openSidebar, collapsed, toggleSidebar) 를 페이지에서 꺼내는 훅
// [이유] react-router useOutletContext 의 타입 안전 래퍼 — 페이지마다 동일 시그니처 사용.
//         W3(design-alignment): collapsed/toggleSidebar 추가 — 데스크톱 사이드바 collapse 토글 배선.
// [사이드 이팩트] 기존 소비처(페이지 컴포넌트)는 { viewport, openSidebar } 만 구조분해 사용하므로 추가 필드에 의한 회귀 없음
// [수정 시 고려사항] App.tsx 의 context 형태 변경 시 본 ShellContext 타입 동기화.
//                   collapsed 는 세션 상태(localStorage 지속 없음) — 과설계 방지(ADR-TR9).

import { useOutletContext } from 'react-router-dom';

import type { Viewport } from './useViewport.js';

export interface ShellContext {
  viewport: Viewport;
  openSidebar: () => void;
  /** 데스크톱 사이드바 collapse 상태 (true = 접힘 60px, false = 펼침 232px). 모바일에서는 항상 false */
  collapsed: boolean;
  /** 데스크톱 사이드바 collapse 토글 함수. 모바일에서는 no-op */
  toggleSidebar: () => void;
}

export function useShell(): ShellContext {
  return useOutletContext<ShellContext>();
}
